(function () {
  'use strict';

  if (window.__cozyFreeSwatchesFilterSearchLoaded) return;
  window.__cozyFreeSwatchesFilterSearchLoaded = true;

  var storageKey = 'cozyology-free-swatches-filter-search:' + window.location.pathname;
  var state = { query: '', productType: '', bestSeller: false };
  var scheduled = false;
  var pageLoadToken = 0;
  var mergingSections = new WeakSet();
  var catalogIndex = null;
  var catalogIndexPromise = null;
  var nativeFilterGroups = [
    { label: 'Color', attribute: 'data-filter-color' },
    { label: 'Fabric', attribute: 'data-filter-material' },
    { label: 'Light Blocking', attribute: 'data-filter-light-control' },
    { label: 'Texture', attribute: 'data-filter-texture' },
    { label: 'Function', attribute: 'data-filter-function' },
    { label: 'Collection', attribute: 'data-filter-collection' }
  ];
  var productTypes = [
    { value: 'drapery', label: 'Drapery' },
    { value: 'sheer', label: 'Sheer' },
    { value: 'roman', label: 'Roman Shade' },
    { value: 'handwoven', label: 'Handwoven Shade' },
    { value: 'roller', label: 'Roller Shade' }
  ];

  function materialAvailableForProductType() {
    return state.productType !== 'handwoven' && state.productType !== 'roller';
  }

  try {
    var saved = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
    state.query = saved.query || '';
    state.productType = saved.productType || '';
    state.bestSeller = saved.bestSeller === true;
  } catch (error) {
    state.query = '';
    state.productType = '';
    state.bestSeller = false;
  }
  if (!productTypes.some(function (type) { return type.value === state.productType; })) {
    state.productType = '';
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  var controlIcons = {
    fabric: '<span class="free-swatches-control-icon free-swatches-control-icon--fabric" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><path d="M4 3v14M8 3v14M12 3v14M16 3v14M3 5h14M3 10h14M3 15h14"></path></svg></span>',
    color: '<span class="free-swatches-control-icon free-swatches-control-icon--color" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><circle cx="7.2" cy="10" r="4.6"></circle><circle cx="12.8" cy="10" r="4.6"></circle></svg></span>',
    product: '<span class="free-swatches-control-icon free-swatches-control-icon--product" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><path d="M3.5 3.5h13v13h-13zM10 3.5v13M6.2 3.5c1.2 3.9 1.2 9.1 0 13M13.8 3.5c-1.2 3.9-1.2 9.1 0 13"></path></svg></span>',
    sort: '<span class="free-swatches-control-icon free-swatches-control-icon--sort" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><path d="M6 3v14m0-14L3.5 5.5M6 3l2.5 2.5M14 17V3m0 14-2.5-2.5M14 17l2.5-2.5"></path></svg></span>',
    bestseller: '<span class="free-swatches-control-icon free-swatches-control-icon--bestseller" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><path d="m10 2.8 2.1 4.3 4.8.7-3.5 3.4.8 4.8-4.2-2.3L5.8 16l.8-4.8-3.5-3.4 4.8-.7z"></path></svg></span>',
    lightblocking: '<span class="free-swatches-control-icon free-swatches-control-icon--lightblocking" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><circle cx="10" cy="10" r="3.2"></circle><path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.3 4.3l1.4 1.4M14.3 14.3l1.4 1.4M15.7 4.3l-1.4 1.4M5.7 14.3l-1.4 1.4"></path></svg></span>',
    texture: '<span class="free-swatches-control-icon free-swatches-control-icon--texture" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><path d="M2.5 6c2.5-2.2 5-2.2 7.5 0s5 2.2 7.5 0M2.5 10c2.5-2.2 5-2.2 7.5 0s5 2.2 7.5 0M2.5 14c2.5-2.2 5-2.2 7.5 0s5 2.2 7.5 0"></path></svg></span>',
    function: '<span class="free-swatches-control-icon free-swatches-control-icon--function" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><path d="M3 5h5M12 5h5M3 10h9M16 10h1M3 15h2M9 15h8"></path><circle cx="10" cy="5" r="2"></circle><circle cx="14" cy="10" r="2"></circle><circle cx="7" cy="15" r="2"></circle></svg></span>',
    collection: '<span class="free-swatches-control-icon free-swatches-control-icon--collection" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation"><path d="M3 5.5h5l1.4 1.7H17v8.3H3zM3 5.5V4h5l1.2 1.5"></path></svg></span>'
  };

  var filterHeadingIconNames = {
    'product type': 'product',
    'best seller': 'bestseller',
    'best sellers': 'bestseller',
    'fabric': 'fabric',
    'material': 'fabric',
    'color': 'color',
    'light blocking': 'lightblocking',
    'light control': 'lightblocking',
    'texture': 'texture',
    'function': 'function',
    'collection': 'collection',
    'sort by': 'sort'
  };

  var colorSwatchMap = {
    'sheer white': '#f5f3ee',
    'white': '#ffffff',
    'ivory': '#eee7d7',
    'cream': '#eadfc9',
    'beige': '#cdb894',
    'tan': '#b99b72',
    'brown': '#876247',
    'yellow': '#d9b650',
    'gold': '#b89448',
    'gray': '#999995',
    'grey': '#999995',
    'black': '#252525',
    'pink': '#d8a1aa',
    'purple': '#8d7198',
    'green': '#6f8565',
    'blue': '#6f8fa9',
    'red': '#b45d55',
    'orange': '#d28752'
  };

  function controlIcon(name) {
    return controlIcons[name] || '';
  }

  function colorSwatchHtml(label) {
    var key = normalize(label);
    var color = colorSwatchMap[key] || '#c9c4bb';
    return '<span class="free-swatches-color-dot" style="--free-swatches-color:' + color + '" aria-hidden="true"></span>';
  }

  function saveState() {
    try {
      if (state.query || state.productType || state.bestSeller) {
        window.sessionStorage.setItem(storageKey, JSON.stringify(state));
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {
      /* Storage can be disabled; all controls still work for the current render. */
    }
  }

  function sectionFor(node) {
    return node && node.closest('[data-section-id]');
  }

  function itemLabel(item) {
    var label = item && item.querySelector('.filter-group__item__text');
    if (!label) return '';
    var copy = label.cloneNode(true);
    copy.querySelectorAll('svg').forEach(function (icon) { icon.remove(); });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function nativeGroup(section, label) {
    var wanted = normalize(label);
    return Array.prototype.find.call(section.querySelectorAll('.filters .filter-group'), function (group) {
      if (group.classList.contains('filter-group--applied')) return false;
      var heading = group.querySelector('.filter-group__heading__text');
      var sourceLabel = group.getAttribute('data-fs-native-label') || (heading && heading.textContent);
      return normalize(sourceLabel) === wanted;
    }) || null;
  }

  function nativeOptions(section, label) {
    var group = nativeGroup(section, label);
    if (!group) return [];
    return Array.prototype.map.call(group.querySelectorAll('.filter-group__item'), function (item) {
      var input = item.querySelector('.filter-group__checkbox[type="checkbox"]');
      var count = item.querySelector('.filter-group__item__count');
      return input ? {
        input: input,
        label: itemLabel(item),
        value: input.value,
        active: input.checked,
        disabled: input.disabled,
        count: count ? count.textContent.trim() : ''
      } : null;
    }).filter(Boolean);
  }


  function filterToken(value) {
    var raw = String(value || '').trim();
    var metaobjectId = raw.match(/(?:Metaobject\/)?(\d{8,})$/i);
    return metaobjectId ? metaobjectId[1] : normalize(raw);
  }

  function splitFilterValues(value) {
    return String(value || '').split('|').map(filterToken).filter(Boolean);
  }

  function catalogCardFromElement(card) {
    var nativeValues = {};
    nativeFilterGroups.forEach(function (group) {
      nativeValues[normalize(group.label)] = splitFilterValues(card.getAttribute(group.attribute));
    });
    return {
      key: cardKey(card),
      productTypes: splitFilterValues(card.getAttribute('data-product-types')),
      bestSeller: card.getAttribute('data-best-seller') === 'true',
      searchText: normalize(card.getAttribute('data-search-text')),
      nativeValues: nativeValues
    };
  }

  function collectCatalogCards(root, map) {
    root.querySelectorAll('[data-free-swatches-card]').forEach(function (card) {
      var data = catalogCardFromElement(card);
      if (data.key && !map.has(data.key)) map.set(data.key, data);
    });
  }

  var swatchPageRequests = new Map();
  var swatchPageQueue = Promise.resolve();

  function fetchSwatchPageAttempt(url, errorMessage, attempt) {
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (response.status === 429 && attempt < 2) {
        var retryAfter = Number(response.headers.get('Retry-After'));
        var delay = Number.isFinite(retryAfter) && retryAfter > 0
          ? retryAfter * 1000
          : 800 * Math.pow(2, attempt);
        return new Promise(function (resolve) {
          window.setTimeout(resolve, delay);
        }).then(function () {
          return fetchSwatchPageAttempt(url, errorMessage, attempt + 1);
        });
      }
      if (!response.ok) {
        throw new Error(errorMessage + ' (HTTP ' + response.status + ')');
      }
      return response.text();
    });
  }

  function fetchSwatchPage(url, errorMessage) {
    var normalizedUrl = new URL(url, window.location.origin);
    normalizedUrl.hash = '';
    normalizedUrl.searchParams.sort();
    var key = normalizedUrl.toString();
    if (swatchPageRequests.has(key)) return swatchPageRequests.get(key);

    var request = swatchPageQueue
      .catch(function () {})
      .then(function () {
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 150);
        });
      })
      .then(function () {
        return fetchSwatchPageAttempt(key, errorMessage, 0);
      });

    swatchPageQueue = request.catch(function () {});
    swatchPageRequests.set(key, request);
    request.catch(function () {
      if (swatchPageRequests.get(key) === request) {
        swatchPageRequests.delete(key);
      }
    });
    return request;
  }

  function cleanCatalogUrl(section, page) {
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0 || key === 'page' || key === 'section_id') {
        url.searchParams.delete(key);
      }
    });
    url.searchParams.set('page', String(page || 1));
    url.searchParams.set('section_id', section.getAttribute('data-section-id'));
    return url;
  }

  function catalogPageCount(parsed) {
    var max = 1;
    parsed.querySelectorAll('.pagination-row a[href]').forEach(function (link) {
      try {
        var page = parseInt(new URL(link.href, window.location.origin).searchParams.get('page') || '1', 10);
        if (page > max) max = page;
      } catch (error) {
        /* Ignore malformed pagination links. */
      }
    });
    return max;
  }

  function ensureCatalogIndex(section) {
    if (catalogIndex) return Promise.resolve(catalogIndex);
    if (catalogIndexPromise) return catalogIndexPromise;

    catalogIndexPromise = fetchSwatchPage(
      cleanCatalogUrl(section, 1).toString(),
      'Unable to load the swatch filter index'
    )
      .then(function (html) {
        var firstPage = new DOMParser().parseFromString(html, 'text/html');
        var pages = catalogPageCount(firstPage);
        var requests = [];
        for (var page = 2; page <= pages; page += 1) {
          requests.push(fetchSwatchPage(
            cleanCatalogUrl(section, page).toString(),
            'Unable to load the swatch filter index'
          ));
        }
        return Promise.all(requests).then(function (responses) {
          var map = new Map();
          collectCatalogCards(firstPage, map);
          responses.forEach(function (responseHtml) {
            collectCatalogCards(new DOMParser().parseFromString(responseHtml, 'text/html'), map);
          });
          catalogIndex = Array.from(map.values());
          return catalogIndex;
        });
      })
      .then(function (index) {
        catalogIndexPromise = null;
        scheduleHydrate();
        return index;
      })
      .catch(function (error) {
        catalogIndexPromise = null;
        console.error('Free Swatches filter index load failed:', error);
        return null;
      });

    return catalogIndexPromise;
  }

  function activeNativeSelections(section) {
    var selections = {};
    nativeFilterGroups.forEach(function (group) {
      selections[normalize(group.label)] = nativeOptions(section, group.label)
        .filter(function (option) { return option.active; })
        .map(function (option) { return filterToken(option.value); });
    });
    return selections;
  }

  function catalogCardMatches(card, productType, bestSeller, query, selections) {
    if (productType) {
      var productTypeLabels = {
        drapery: 'drapery',
        sheer: 'sheer',
        roman: 'roman shade',
        handwoven: 'handwoven shade',
        roller: 'roller shade'
      };
      if (card.productTypes.indexOf(productTypeLabels[productType]) === -1) return false;
    }
    if (bestSeller && !card.bestSeller) return false;
    if (query && card.searchText.indexOf(normalize(query)) === -1) return false;

    return nativeFilterGroups.every(function (group) {
      var key = normalize(group.label);
      var selected = selections[key] || [];
      if (!selected.length) return true;
      var values = card.nativeValues[key] || [];
      return selected.some(function (value) { return values.indexOf(value) !== -1; });
    });
  }

  function unifiedCount(section, overrides) {
    if (!catalogIndex) return null;
    overrides = overrides || {};
    var selections = activeNativeSelections(section);
    if (overrides.nativeLabel) {
      selections[normalize(overrides.nativeLabel)] = (overrides.nativeValues || []).map(filterToken);
    }
    var productType = Object.prototype.hasOwnProperty.call(overrides, 'productType') ? overrides.productType : state.productType;
    var bestSeller = Object.prototype.hasOwnProperty.call(overrides, 'bestSeller') ? overrides.bestSeller : state.bestSeller;
    var query = Object.prototype.hasOwnProperty.call(overrides, 'query') ? overrides.query : state.query;
    return catalogIndex.reduce(function (count, card) {
      return count + (catalogCardMatches(card, productType, bestSeller, query, selections) ? 1 : 0);
    }, 0);
  }

  function prospectiveNativeCount(section, label, option) {
    var selected = activeNativeSelections(section)[normalize(label)] || [];
    if (!option.active) selected = selected.concat(filterToken(option.value));
    return unifiedCount(section, { nativeLabel: label, nativeValues: selected });
  }

  function updateAllFiltersCount(section) {
    var count = state.productType ? 1 : 0;
    if (state.bestSeller) count += 1;

    nativeFilterGroups.forEach(function (group) {
      count += nativeOptions(section, group.label).filter(function (option) { return option.active; }).length;
    });

    var nativeBestSellers = nativeOptions(section, 'Best Seller').some(function (option) { return option.active; });
    if (nativeBestSellers && !state.bestSeller) count += 1;

    var filterButton = section.querySelector('.utility-bar__left [data-toggle-filters]');
    if (!filterButton) return;

    var countNode = filterButton.querySelector('.toggle-btn__count');
    if (count > 0) {
      if (!countNode) {
        countNode = document.createElement('span');
        countNode.className = 'toggle-btn__count';
        var labelNode = Array.prototype.find.call(filterButton.children, function (node) {
          return node.tagName === 'SPAN' && /^(?:Filter|All Filters)$/i.test(node.textContent.replace(/\s+/g, ' ').trim());
        });
        if (labelNode) labelNode.insertAdjacentElement('afterend', countNode);
        else filterButton.appendChild(countNode);
      }
      countNode.textContent = '(' + count + ')';
    } else if (countNode) {
      countNode.remove();
    }
  }

  function syncUnifiedCounts(section) {
    updateAllFiltersCount(section);
    ensureCatalogIndex(section);
    if (!catalogIndex) return;

    nativeFilterGroups.forEach(function (group) {
      if (normalize(group.label) === 'fabric' && !materialAvailableForProductType()) return;
      nativeOptions(section, group.label).forEach(function (option) {
        var count = prospectiveNativeCount(section, group.label, option);
        var item = option.input.closest('.filter-group__item');
        var countNode = item && item.querySelector('.filter-group__item__count');
        if (countNode) countNode.textContent = String(count);
        option.input.disabled = count === 0;
        if (item) {
          item.classList.toggle('filter-group__item--disabled', count === 0);
          item.setAttribute('aria-disabled', count === 0 ? 'true' : 'false');
        }
      });
    });
  }

  function setNativeOption(section, groupLabel, optionValue) {
    var options = nativeOptions(section, groupLabel);
    var target = options.find(function (option) { return option.value === optionValue; });
    if (!target || target.disabled) return;

    target.input.checked = !target.input.checked;
    target.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function clearNativeGroup(section, groupLabel) {
    var active = nativeOptions(section, groupLabel).filter(function (option) { return option.active; });
    if (!active.length) return;
    active.forEach(function (option) { option.input.checked = false; });
    active[0].input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncMaterialAvailability(section) {
    var group = nativeGroup(section, 'Fabric');
    var available = materialAvailableForProductType();
    if (group) {
      group.classList.toggle('free-swatches-material-unavailable', !available);
      group.hidden = !available;
      group.setAttribute('aria-hidden', available ? 'false' : 'true');
    }
    if (!available) clearNativeGroup(section, 'Fabric');
    return available;
  }

  function groupClassification(group) {
    return normalize([
      group.getAttribute('data-series'),
      group.querySelector('h2') && group.querySelector('h2').textContent,
      group.querySelector('.product-list-intro') && group.querySelector('.product-list-intro').textContent
    ].filter(Boolean).join(' '));
  }

  function cardMatchesProductType(card, type) {
    if (!type) return true;
    var labels = {
      drapery: 'drapery',
      sheer: 'sheer',
      roman: 'roman shade',
      handwoven: 'handwoven shade',
      roller: 'roller shade'
    };
    var wanted = labels[type];
    if (!wanted) return false;
    var values = ' ' + normalize(card.getAttribute('data-product-types')) + ' ';
    return values.indexOf(' ' + wanted + ' ') !== -1;
  }

  function productTypeCount(section, type) {
    var unified = unifiedCount(section, { productType: type });
    if (unified !== null) return unified;
    var count = 0;
    section.querySelectorAll('[data-free-swatches-card]').forEach(function (card) {
      if (cardMatchesProductType(card, type)) count += 1;
    });
    return count;
  }

  function bestSellerCount(section) {
    var unified = unifiedCount(section, { bestSeller: true });
    if (unified !== null) return unified;
    return section.querySelectorAll('[data-free-swatches-card][data-best-seller="true"]').length;
  }

  function quickFilterHtml(section, label) {
    var options = nativeOptions(section, label);
    if (!options.length) return '';
    var displayLabel = normalize(label) === 'fabric' ? 'Material' : label;
    var active = options.filter(function (option) { return option.active; });
    var isCompactMobile = window.innerWidth <= 767;
    var buttonLabel = isCompactMobile ? displayLabel : (active.length === 1 ? active[0].label : displayLabel + (active.length ? ' (' + active.length + ')' : ''));
    var iconName = normalize(label) === 'fabric' ? 'fabric' : 'color';
    var buttonIcon = iconName === 'color' && active.length === 1 ? colorSwatchHtml(active[0].label) : controlIcon(iconName);
    var html = '<div class="free-swatches-quick__dropdown" data-fs-dropdown>';
    html += '<button type="button" class="free-swatches-quick__button' + (active.length ? ' is-active' : '') + '" data-fs-quick-trigger aria-expanded="false">';
    html += '<span class="free-swatches-quick__button-label">' + buttonIcon + '<span>' + escapeHtml(buttonLabel) + '</span></span><span class="free-swatches-quick__arrow" aria-hidden="true">⌄</span></button>';
    html += '<div class="free-swatches-quick__menu" role="menu">';
    options.forEach(function (option) {
      html += '<button type="button" class="free-swatches-quick__option' + (option.active ? ' is-active' : '') + '"';
      html += ' data-fs-native-group="' + escapeHtml(label) + '" data-fs-native-option="' + escapeHtml(option.value) + '"';
      if (option.disabled) html += ' disabled';
      html += '><span class="free-swatches-quick__option-label">';
      if (iconName === 'color') html += colorSwatchHtml(option.label);
      html += '<span>' + escapeHtml(option.label) + '</span></span>';
      if (option.count) html += '<span class="free-swatches-quick__count">' + escapeHtml(option.count) + '</span>';
      html += '</button>';
    });
    if (active.length) {
      html += '<div class="free-swatches-quick__menu-footer"><button type="button" class="free-swatches-quick__clear" data-fs-clear-native-group="' + escapeHtml(label) + '"><span>Clear ' + escapeHtml(displayLabel) + '</span><span aria-hidden="true">×</span></button></div>';
    }
    html += '</div></div>';
    return html;
  }
  function productTypeQuickHtml(section) {
    var active = productTypes.find(function (type) { return type.value === state.productType; });
    var buttonLabel = window.innerWidth <= 767 ? 'Type' : (active ? active.label : 'Product Type');
    var html = '<div class="free-swatches-quick__dropdown" data-fs-dropdown>';
    html += '<button type="button" class="free-swatches-quick__button' + (active ? ' is-active' : '') + '" data-fs-quick-trigger aria-expanded="false">';
    html += '<span class="free-swatches-quick__button-label">' + controlIcon('product') + '<span>' + escapeHtml(buttonLabel) + '</span></span><span class="free-swatches-quick__arrow" aria-hidden="true">⌄</span></button>';
    html += '<div class="free-swatches-quick__menu" role="menu">';
    productTypes.forEach(function (type) {
      var count = productTypeCount(section, type.value);
      var isActive = state.productType === type.value;
      var isDisabled = count === 0;
      html += '<button type="button" class="free-swatches-quick__option' + (isActive ? ' is-active' : '') + '" data-fs-product-type-option="' + type.value + '"' + (isDisabled ? ' disabled aria-disabled="true"' : '') + '>';
      html += '<span class="free-swatches-quick__option-label">' + controlIcon('product') + '<span>' + type.label + '</span></span><span class="free-swatches-quick__count">' + count + '</span></button>';
    });
    if (active) {
      html += '<div class="free-swatches-quick__menu-footer"><button type="button" class="free-swatches-quick__clear" data-fs-clear-client="productType"><span>Clear Product Type</span><span aria-hidden="true">×</span></button></div>';
    }
    html += '</div></div>';
    return html;
  }
  function renderQuickFilters(section) {
    var search = section.querySelector('[data-free-swatches-search]');
    if (!search) return;

    var toolbar = section.querySelector('[data-free-swatches-quick]');
    if (!toolbar) {
      toolbar = document.createElement('div');
      toolbar.className = 'free-swatches-quick';
      toolbar.setAttribute('data-free-swatches-quick', '');
      search.insertAdjacentElement('afterend', toolbar);
    }

    var signature = [
      state.productType,
      nativeOptions(section, 'Fabric').map(function (o) { return [o.value, o.active, o.disabled, o.count].join(':'); }).join('|'),
      nativeOptions(section, 'Color').map(function (o) { return [o.value, o.active, o.disabled, o.count].join(':'); }).join('|'),
      productTypes.map(function (type) { return type.value + ':' + productTypeCount(section, type.value); }).join('|')
    ].join('::');

    if (toolbar.getAttribute('data-fs-signature') === signature) return;
    toolbar.setAttribute('data-fs-signature', signature);
    toolbar.innerHTML = productTypeQuickHtml(section) +
      quickFilterHtml(section, 'Color') +
      (materialAvailableForProductType() ? quickFilterHtml(section, 'Fabric') : '');
  }

  function syncFilterOpenState(section) {
    var filterContainer = section && section.querySelector('.filter-container');
    if (!filterContainer) return;
    section.classList.toggle(
      'fs-desktop-filter-open',
      filterContainer.classList.contains('filter-container--show-filters-desktop')
    );
  }

  function arrangeToolbar(section) {
    var search = section.querySelector('[data-free-swatches-search]');
    var quick = section.querySelector('[data-free-swatches-quick]');
    var utility = section.querySelector('.utility-bar');
    if (!search || !quick || !utility) return;

    var filterContainer = section.querySelector('.filter-container');
    if (filterContainer) {
      syncFilterOpenState(section);
      if (!filterContainer.hasAttribute('data-fs-open-state-bound')) {
        filterContainer.setAttribute('data-fs-open-state-bound', '');
        new MutationObserver(function () {
          syncFilterOpenState(section);
        }).observe(filterContainer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    utility.classList.add('free-swatches-toolbar');
    if (search.parentElement !== utility) utility.insertAdjacentElement('afterbegin', search);
    if (quick.parentElement !== utility) search.insertAdjacentElement('afterend', quick);

    var filterButton = utility.querySelector('.utility-bar__left [data-toggle-filters]');
    if (filterButton) {
      Array.prototype.some.call(filterButton.querySelectorAll('span'), function (node) {
        var label = node.textContent.replace(/\s+/g, ' ').trim();
        var match = label.match(/^(?:Filter|All Filters)(\s*\(\d+\))?$/i);
        if (!match) return false;
        node.textContent = 'All Filters' + (match[1] || '');
        return true;
      });
      filterButton.setAttribute('aria-label', 'Open or close all filters');

      if (!filterButton.hasAttribute('data-fs-return-to-filter-start-bound')) {
        filterButton.setAttribute('data-fs-return-to-filter-start-bound', '');
      }

    }

    var mobileAllFilters = quick.querySelector('[data-fs-mobile-all-filters]');
    if (filterButton) {
      if (!mobileAllFilters) {
        mobileAllFilters = filterButton.cloneNode(true);
        mobileAllFilters.removeAttribute('id');
        mobileAllFilters.setAttribute('data-fs-mobile-all-filters', '');
        mobileAllFilters.classList.add('free-swatches-mobile-all-filters');
        quick.appendChild(mobileAllFilters);
      } else {
        mobileAllFilters.innerHTML = filterButton.innerHTML;
      }

      Array.prototype.some.call(mobileAllFilters.querySelectorAll('span'), function (node) {
        var label = node.textContent.replace(/\s+/g, ' ').trim();
        var match = label.match(/^All Filters(\s*\(\d+\))?$/i);
        if (!match) return false;
        node.textContent = 'Filters' + (match[1] || '');
        return true;
      });

      if (!mobileAllFilters.hasAttribute('data-fs-mobile-bound')) {
        mobileAllFilters.setAttribute('data-fs-mobile-bound', '');
        mobileAllFilters.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var sourceButton = section.querySelector('.utility-bar__left [data-toggle-filters]');
          if (!sourceButton) return;
          sourceButton.click();
          window.setTimeout(function () {
            mobileAllFilters.setAttribute('aria-expanded', sourceButton.getAttribute('aria-expanded') || 'false');
          }, 0);
        });
      }
    } else if (mobileAllFilters) {
      mobileAllFilters.remove();
    }

    var sortButton = utility.querySelector('.link-dropdown__button');
    var sortText = sortButton && sortButton.querySelector('.link-dropdown__button-text');
    if (sortText && !sortButton.querySelector('.free-swatches-control-icon--sort')) {
      sortText.insertAdjacentHTML('beforebegin', controlIcon('sort'));
    }
  }

  function normalizeFilterContent(section) {
    var form = section.querySelector('.filters #CollectionFilterForm');
    if (!form) return;

    var displayNames = {
      'best seller': 'Best Sellers',
      'fabric': 'Material',
      'light blocking': 'Light Control'
    };
    var materialValues = ['linen', 'cotton', 'wool', 'velvet', '100 linen cotton'];

    Array.prototype.forEach.call(form.querySelectorAll(':scope > .filter-group:not(.filter-group--applied)'), function (group) {
      var headingText = group.querySelector('.filter-group__heading__text');
      if (!headingText) return;

      var sourceLabel = group.getAttribute('data-fs-native-label') || headingText.textContent.replace(/\s+/g, ' ').trim();
      if (!group.hasAttribute('data-fs-native-label')) group.setAttribute('data-fs-native-label', sourceLabel);
      var sourceKey = normalize(sourceLabel);
      var displayName = displayNames[sourceKey] || sourceLabel;

      if (sourceKey === 'sort by') {
        group.hidden = true;
        group.style.setProperty('display', 'none', 'important');
        return;
      }

      if (normalize(headingText.textContent) !== normalize(displayName)) {
        headingText.textContent = displayName;
      }

      if (sourceKey === 'fabric') {
        Array.prototype.forEach.call(group.querySelectorAll('.filter-group__item'), function (item) {
          var input = item.querySelector('.filter-group__checkbox[type="checkbox"]');
          if (input && materialValues.indexOf(normalize(input.value)) === -1) item.remove();
        });
      }

      if (sourceKey === 'best seller') {
        group.classList.add('free-swatches-best-sellers-group');
        var container = group.querySelector('.toggle-target-container');
        var nativeItems = Array.prototype.filter.call(group.querySelectorAll('.filter-group__item'), function (item) {
          return item.querySelector('.filter-group__checkbox[type="checkbox"]');
        });
        nativeItems.forEach(function (item) {
          item.classList.add('free-swatches-best-sellers-native');
          item.hidden = true;
          item.style.setProperty('display', 'none', 'important');
        });

        if (container && nativeItems.length) {
          var count = bestSellerCount(section);
          var active = state.bestSeller;
          var disabled = count === 0;
          var custom = container.querySelector('[data-fs-best-sellers]');

          if (!custom) {
            custom = document.createElement('button');
            custom.type = 'button';
            custom.className = 'filter-group__item free-swatches-client-option free-swatches-best-sellers-option';
            custom.setAttribute('data-fs-best-sellers', '');
            custom.setAttribute('role', 'checkbox');
            custom.innerHTML = '<span class="filter-group__item__text">Best Sellers</span>' +
              '<span class="filter-group__item__count"></span>';
            container.insertAdjacentElement('afterbegin', custom);
          }

          custom.classList.toggle('is-active', active);
          custom.setAttribute('aria-checked', active ? 'true' : 'false');
          custom.disabled = disabled;
          custom.querySelector('.filter-group__item__count').textContent = String(count);
        }
      }
    });

    var desiredOrder = ['product type', 'best seller', 'color', 'fabric', 'light blocking', 'texture', 'function', 'collection'];
    var directGroups = Array.prototype.slice.call(form.querySelectorAll(':scope > .filter-group:not(.filter-group--applied)'));
    var bySource = {};
    directGroups.forEach(function (group) {
      var heading = group.querySelector('.filter-group__heading__text');
      var source = group.getAttribute('data-fs-native-label') || (heading && heading.textContent) || '';
      bySource[normalize(source)] = group;
    });
    var desiredGroups = desiredOrder.map(function (key) { return bySource[key]; }).filter(Boolean);
    var currentOrder = directGroups.filter(function (group) {
      return desiredGroups.indexOf(group) !== -1;
    });
    var needsReorder = currentOrder.length !== desiredGroups.length || currentOrder.some(function (group, index) {
      return group !== desiredGroups[index];
    });

    if (needsReorder) {
      var anchor = bySource['sort by'] || form.querySelector('noscript');
      desiredGroups.forEach(function (group) { form.insertBefore(group, anchor || null); });
    }

    var appliedGroup = section.querySelector('.filter-group--applied');
    if (appliedGroup) {
      var nativeBestSellerApplied = Array.prototype.filter.call(appliedGroup.querySelectorAll('.filter-group__applied-item[href]'), function (item) {
        return (item.getAttribute('href') || '').indexOf('filter.p.m.custom.best_seller') !== -1;
      });
      var existingCombined = appliedGroup.querySelector('[data-fs-best-sellers-applied]');

      if (nativeBestSellerApplied.length) {
        nativeBestSellerApplied.forEach(function (item) {
          item.hidden = true;
          item.style.setProperty('display', 'none', 'important');
        });

        if (!existingCombined) {
          var clearUrl = new URL(window.location.href);
          clearUrl.searchParams.delete('filter.p.m.custom.best_seller');
          existingCombined = document.createElement('a');
          existingCombined.className = 'filter-group__applied-item';
          existingCombined.setAttribute('data-fs-best-sellers-applied', '');
          existingCombined.href = clearUrl.pathname + clearUrl.search;
          existingCombined.innerHTML = '<span class="filter-group__applied-item__text">Best Sellers</span>' +
            '<span class="filter-group__applied-item__icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"></path></svg></span>';
          nativeBestSellerApplied[0].insertAdjacentElement('beforebegin', existingCombined);
        }
      } else if (existingCombined) {
        existingCombined.remove();
      }
    }
  }

  function decorateFilterGroups(section) {
    section.querySelectorAll('.filters #CollectionFilterForm .filter-group:not(.filter-group--applied)').forEach(function (group) {
      var headingText = group.querySelector('.filter-group__heading__text');
      if (!headingText || headingText.querySelector('.free-swatches-filter-heading-icon')) return;
      var iconName = filterHeadingIconNames[normalize(headingText.textContent)];
      if (!iconName) return;
      var holder = document.createElement('span');
      holder.className = 'free-swatches-filter-heading-icon';
      holder.innerHTML = controlIcon(iconName);
      headingText.insertAdjacentElement('afterbegin', holder);
    });
  }

  function ensureClientProductTypeFilter(section) {
    var form = section.querySelector('.filters #CollectionFilterForm');
    if (!form) return;
    var existing = form.querySelector('[data-fs-client-product-type]');
    var signature = state.productType + ':' + productTypes.map(function (type) {
      return type.value + ':' + productTypeCount(section, type.value);
    }).join('|');
    if (existing && existing.getAttribute('data-fs-signature') === signature) return;
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'filter-group free-swatches-client-filter-group';
      existing.setAttribute('data-fs-client-product-type', '');
      form.insertAdjacentElement('afterbegin', existing);
    }
    existing.setAttribute('data-fs-signature', signature);
    existing.innerHTML = '<div class="filter-group__heading"><div class="filter-group__heading__text">Product Type</div></div>' +
      '<div class="filter-group__items"><div class="toggle-target-container">' +
      productTypes.map(function (type) {
        var count = productTypeCount(section, type.value);
        var isActive = state.productType === type.value;
        var isDisabled = count === 0;
        return '<button type="button" class="filter-group__item free-swatches-client-option' + (isActive ? ' is-active' : '') + '" data-fs-client-type-option="' + type.value + '" role="checkbox" aria-checked="' + isActive + '"' + (isDisabled ? ' disabled aria-disabled="true"' : '') + '>' +
          '<span class="filter-group__item__text">' + type.label + '</span><span class="filter-group__item__count">' + count + '</span></button>';
      }).join('') + '</div></div>';
  }

  function renderClientApplied(section) {
    var inner = section.querySelector('.filters__inner');
    var heading = inner && inner.querySelector('.filters__heading');
    if (!heading) return;

    var nativeGroup = inner.querySelector('.filter-group--applied:not([data-fs-client-applied-group])');
    var syntheticGroup = inner.querySelector('[data-fs-client-applied-group]');
    var box = inner.querySelector('[data-fs-client-applied]');
    var hasClientFilters = state.productType || state.bestSeller;

    if (!hasClientFilters) {
      if (syntheticGroup) syntheticGroup.remove();
      else if (box) box.remove();
      return;
    }

    if (nativeGroup) {
      if (syntheticGroup) syntheticGroup.remove();
      box = nativeGroup.querySelector('[data-fs-client-applied]');
      if (!box) {
        box = document.createElement('span');
        box.className = 'free-swatches-client-applied';
        box.setAttribute('data-fs-client-applied', '');
        var nativeItems = nativeGroup.querySelector('.filter-group__items');
        var firstNativeChip = nativeItems && nativeItems.querySelector('.filter-group__applied-item');
        var clearRow = nativeItems && nativeItems.querySelector('.filter-group__clear-row');
        if (nativeItems) nativeItems.insertBefore(box, firstNativeChip || clearRow || null);
      }
    } else {
      if (!syntheticGroup) {
        syntheticGroup = document.createElement('div');
        syntheticGroup.className = 'filter-group filter-group--applied free-swatches-client-applied-group';
        syntheticGroup.setAttribute('data-fs-client-applied-group', '');
        syntheticGroup.innerHTML = '<div class="filter-group__heading"><div class="filter-group__heading__text">Applied Filters</div></div>' +
          '<div class="filter-group__items"><span class="free-swatches-client-applied" data-fs-client-applied></span>' +
          '<div class="filter-group__clear-row"><a class="filter-group__clear-link" href="' + escapeHtml(window.location.pathname) + '">Clear all</a></div></div>';
        heading.insertAdjacentElement('afterend', syntheticGroup);
      }
      box = syntheticGroup.querySelector('[data-fs-client-applied]');
    }

    var closeIcon = '<span class="filter-group__applied-item__icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"></path></svg></span>';
    var chips = [];
    if (state.productType) {
      var type = productTypes.find(function (item) { return item.value === state.productType; });
      var typeLabel = type ? type.label : state.productType;
      chips.push('<button type="button" class="filter-group__applied-item free-swatches-client-applied__chip" data-fs-clear-client="productType" aria-label="Remove ' + escapeHtml(typeLabel) + ' filter"><span class="filter-group__applied-item__text">' + escapeHtml(typeLabel) + '</span>' + closeIcon + '</button>');
    }
    if (state.bestSeller) {
      chips.push('<button type="button" class="filter-group__applied-item free-swatches-client-applied__chip" data-fs-clear-client="bestSeller" aria-label="Remove Best Sellers filter"><span class="filter-group__applied-item__text">Best Sellers</span>' + closeIcon + '</button>');
    }
    box.innerHTML = chips.join('');
  }
  function renderMobileApplied(section) {
    var toolbar = section.querySelector('.free-swatches-toolbar');
    if (!toolbar) return;

    var existing = toolbar.querySelector('[data-fs-mobile-applied]');
    var appliedGroup = section.querySelector('.filters__inner .filter-group--applied');
    var sourceItems = appliedGroup ? Array.prototype.filter.call(appliedGroup.querySelectorAll('.filter-group__applied-item'), function (item) {
      return !item.hidden && item.style.display !== 'none';
    }) : [];

    if (!sourceItems.length) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'free-swatches-mobile-applied';
      existing.setAttribute('data-fs-mobile-applied', '');
      toolbar.appendChild(existing);
    }

    existing.innerHTML = '<span class="free-swatches-mobile-applied__label">Selected</span><div class="free-swatches-mobile-applied__items"></div>';
    var items = existing.querySelector('.free-swatches-mobile-applied__items');
    sourceItems.forEach(function (item) { items.appendChild(item.cloneNode(true)); });

    var sourceClear = appliedGroup && appliedGroup.querySelector('.filter-group__clear-link');
    if (sourceClear) {
      var clear = sourceClear.cloneNode(true);
      clear.classList.add('free-swatches-mobile-applied__clear');
      existing.appendChild(clear);
    }
  }

  function revealAllFilterOptions(section) {
    section.querySelectorAll('[data-fs-see-more]').forEach(function (button) { button.remove(); });
    section.querySelectorAll('.free-swatches-option-overflow').forEach(function (item) {
      item.classList.remove('free-swatches-option-overflow');
    });
    section.querySelectorAll('.free-swatches-options-collapsible, .free-swatches-options-expanded').forEach(function (container) {
      container.classList.remove('free-swatches-options-collapsible', 'free-swatches-options-expanded');
    });
    section.querySelectorAll('.free-swatches-has-collapsed-options').forEach(function (items) {
      items.classList.remove('free-swatches-has-collapsed-options');
    });
  }

  function pageStateKey() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    return url.pathname + '?' + url.searchParams.toString();
  }

  function paginationState(section) {
    var pages = [1];
    section.querySelectorAll('.pagination-row a[href]').forEach(function (link) {
      try {
        var page = parseInt(new URL(link.href, window.location.origin).searchParams.get('page') || '1', 10);
        if (page > 0) pages.push(page);
      } catch (error) {
        /* Ignore malformed pagination links. */
      }
    });
    var current = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    pages.push(current);
    return { current: current, max: Math.max.apply(Math, pages) };
  }

  function cardKey(card) {
    return normalize(card.getAttribute('data-search-text'));
  }

  function mergePageListing(section, remoteListing) {
    var localListing = section.querySelector('.filters-adjacent');
    if (!localListing || !remoteListing) return;
    var existingKeys = new Set(Array.prototype.map.call(localListing.querySelectorAll('[data-free-swatches-card]'), cardKey));

    remoteListing.querySelectorAll('[data-free-swatches-group]').forEach(function (remoteGroup) {
      var series = remoteGroup.getAttribute('data-series') || '';
      var localGroup = Array.prototype.find.call(localListing.querySelectorAll('[data-free-swatches-group]'), function (group) {
        return group.getAttribute('data-series') === series;
      });

      if (!localGroup) {
        localGroup = remoteGroup.cloneNode(true);
        localGroup.querySelectorAll('[data-free-swatches-card]').forEach(function (card) {
          existingKeys.add(cardKey(card));
        });
        localListing.appendChild(localGroup);
        return;
      }

      var grid = localGroup.querySelector('.product-grid');
      if (!grid) return;
      remoteGroup.querySelectorAll('[data-free-swatches-card]').forEach(function (remoteCard) {
        var key = cardKey(remoteCard);
        if (!key || existingKeys.has(key)) return;
        existingKeys.add(key);
        grid.appendChild(remoteCard.cloneNode(true));
      });
    });
  }

  function initialVisibleSwatchCount() {
    return window.matchMedia('(max-width: 700px)').matches ? 4 : 12;
  }

  function normalizeMergedGroups(section) {
    var visibleCount = initialVisibleSwatchCount();
    var loadTemplate = section.querySelector('.load-more-container');
    section.querySelectorAll('[data-free-swatches-group]').forEach(function (group) {
      var cards = Array.prototype.slice.call(group.querySelectorAll('[data-free-swatches-card]'));
      cards.forEach(function (card, index) {
        card.classList.toggle('product-item--hidden', index >= visibleCount);
        card.removeAttribute('data-search-restore-load-hidden');
        card.hidden = false;
      });

      var grid = group.querySelector('.product-grid');
      if (!grid) return;
      var typeId = grid.id.replace(/^product-grid-/, '');
      var loadMore = group.querySelector('.load-more-container');
      if (cards.length > visibleCount && !loadMore) {
        if (loadTemplate) {
          loadMore = loadTemplate.cloneNode(true);
          loadMore.removeAttribute('data-search-previous-display');
          loadMore.removeAttribute('data-search-previous-hidden');
          grid.insertAdjacentElement('afterend', loadMore);
        } else {
          loadMore = document.createElement('div');
          loadMore.className = 'load-more-container';
          loadMore.innerHTML = '<div class="load-btn">Load More</div>';
          grid.insertAdjacentElement('afterend', loadMore);
        }
      }
      if (loadMore) {
        loadMore.id = 'load-more-' + typeId;
        loadMore.setAttribute('onclick', "loadMoreProducts('" + typeId.replace(/'/g, "\\'") + "', " + cards.length + ')');
        loadMore.style.display = cards.length > visibleCount ? '' : 'none';
        loadMore.hidden = false;
      }
    });
  }

  function ensureAllPages(section) {
    var key = pageStateKey();
    if (section.getAttribute('data-fs-pages-key') === key) return;
    section.setAttribute('data-fs-pages-key', key);
    section.setAttribute('data-fs-pages-state', 'loading');
    section.classList.remove('free-swatches-all-pages-loaded');
    var token = ++pageLoadToken;
    var pagination = paginationState(section);
    if (pagination.max <= 1) {
      section.setAttribute('data-fs-pages-state', 'loaded');
      section.classList.add('free-swatches-all-pages-loaded');
      return;
    }

    var sectionId = section.getAttribute('data-section-id');
    var requests = [];
    for (var page = 1; page <= pagination.max; page += 1) {
      if (page === pagination.current) continue;
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', sectionId);
      requests.push(fetchSwatchPage(
        url.toString(),
        'Unable to load all swatches'
      ));
    }

    Promise.all(requests).then(function (responses) {
      if (token !== pageLoadToken || section.getAttribute('data-fs-pages-key') !== key) return;
      mergingSections.add(section);
      responses.forEach(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        mergePageListing(section, parsed.querySelector('.filters-adjacent'));
      });
      normalizeMergedGroups(section);
      section.setAttribute('data-fs-pages-state', 'loaded');
      section.classList.add('free-swatches-all-pages-loaded');
      scheduleHydrate();
      window.setTimeout(function () { mergingSections.delete(section); }, 0);
    }).catch(function (error) {
      if (token !== pageLoadToken) return;
      section.setAttribute('data-fs-pages-state', 'error');
      console.error('Free Swatches full search load failed:', error);
      scheduleHydrate();
    });
  }

  function restoreCard(card) {
    card.hidden = false;
    if (card.hasAttribute('data-search-restore-load-hidden')) {
      card.classList.toggle('product-item--hidden', card.getAttribute('data-search-restore-load-hidden') === 'true');
      card.removeAttribute('data-search-restore-load-hidden');
    }
  }

  function hasNativeFilterCriteria() {
    var active = false;
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) active = true;
    });
    return active;
  }

  function ensureEmptyState(section) {
    var listing = section.querySelector('.filters-adjacent');
    if (!listing || !listing.parentNode) return;

    var existingEmptyState = section.querySelector('[data-free-swatches-search-empty]');
    if (existingEmptyState) {
      if (existingEmptyState.parentNode !== listing.parentNode) {
        listing.parentNode.insertBefore(existingEmptyState, listing);
      }
      var existingClear = existingEmptyState.querySelector('[data-free-swatches-search-clear]');
      if (existingClear) {
        existingClear.setAttribute('data-free-swatches-search-clear-all', '');
        existingClear.textContent = 'Clear all filters';
      }
      return;
    }

    var emptyState = document.createElement('div');
    emptyState.className = 'free-swatches-search-empty';
    emptyState.setAttribute('data-free-swatches-search-empty', '');
    emptyState.setAttribute('aria-live', 'polite');
    emptyState.hidden = true;
    emptyState.innerHTML = '<h3>No matching swatches</h3><p>Try removing one or more filters to see more options.</p><button type="button" class="btn btn--primary" data-free-swatches-search-clear data-free-swatches-search-clear-all>Clear all filters</button>';
    listing.parentNode.insertBefore(emptyState, listing);
  }

  var storyPromoObserver = null;

  function bindStoryPromoReveal(section) {
    var promos = section.querySelectorAll('[data-free-swatches-story-promo]');
    if (!promos.length) return;

    if (!('IntersectionObserver' in window)) {
      promos.forEach(function (promo) { promo.classList.add('is-visible'); });
      return;
    }

    if (!storyPromoObserver) {
      storyPromoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      });
    }

    promos.forEach(function (promo) {
      if (promo.hasAttribute('data-fs-story-reveal-bound')) return;
      promo.setAttribute('data-fs-story-reveal-bound', '');
      storyPromoObserver.observe(promo);
    });
  }

  function journeyPromoCount(criteriaActive, matchedCount) {
    if (!criteriaActive) return 3;
    if (matchedCount >= 80) return 3;
    if (matchedCount >= 40) return 2;
    if (matchedCount >= 13) return 1;
    return 0;
  }

  function visibleCardCount(group) {
    return Array.prototype.filter.call(group.querySelectorAll('[data-free-swatches-card]'), function (card) {
      return !card.hidden;
    }).length;
  }

  function revealJourneyPromo(promo) {
    promo.removeAttribute('data-free-swatches-placement-pending');
    promo.hidden = false;
  }

  function placeJourneyPromos(section, matchedCount, criteriaActive) {
    var promos = [
      section.querySelector('[data-free-swatches-discount-promo]'),
      section.querySelector('[data-free-swatches-color-box-promo]'),
      section.querySelector('[data-free-swatches-feeling-lost-promo]')
    ].filter(Boolean);

    promos.forEach(function (promo) {
      promo.setAttribute('data-free-swatches-placement-pending', '');
      promo.hidden = true;
    });

    var promoCount = journeyPromoCount(criteriaActive, matchedCount);
    if (!promoCount || !promos.length) return;

    var groups = Array.prototype.slice.call(section.querySelectorAll('[data-free-swatches-group]'));
    if (!groups.length) return;

    if (!criteriaActive) {
      var isMobile = window.matchMedia('(max-width: 700px)').matches;

      if (isMobile) {
        var mobileFractions = [0.12, 0.23, 0.39];
        var previousMobileIndex = -2;

        promos.slice(0, promoCount).forEach(function (promo, promoIndex) {
          var targetY = document.documentElement.scrollHeight * mobileFractions[promoIndex];
          var minimumIndex = Math.max(0, previousMobileIndex + 2);
          var insertionIndex = Math.min(minimumIndex, groups.length - 1);
          var closestDistance = Infinity;

          for (var groupIndex = minimumIndex; groupIndex < groups.length; groupIndex += 1) {
            var groupY = groups[groupIndex].getBoundingClientRect().top + window.scrollY;
            var distance = Math.abs(groupY - targetY);
            if (distance < closestDistance) {
              closestDistance = distance;
              insertionIndex = groupIndex;
            }
          }
          groups[insertionIndex].insertAdjacentElement('beforebegin', promo);
          previousMobileIndex = insertionIndex;
          revealJourneyPromo(promo);
        });
      } else {
        var desktopIndexes = [6, 25, 36];
        promos.slice(0, promoCount).forEach(function (promo, promoIndex) {
          var targetGroup = groups[desktopIndexes[promoIndex]];
          if (!targetGroup) return;
          targetGroup.insertAdjacentElement('beforebegin', promo);
          revealJourneyPromo(promo);
        });
      }
      return;
    }

    var visibleGroups = groups.filter(function (group) { return !group.hidden; });
    if (!visibleGroups.length) return;

    var fractions = promoCount === 1 ? [0.5] : (promoCount === 2 ? [1 / 3, 2 / 3] : [0.25, 0.5, 0.75]);
    var previousInsertionIndex = -2;

    promos.slice(0, promoCount).forEach(function (promo, promoIndex) {
      var targetCount = Math.ceil(matchedCount * fractions[promoIndex]);
      var cumulative = 0;
      var boundaryIndex = visibleGroups.length - 1;

      for (var groupIndex = 0; groupIndex < visibleGroups.length; groupIndex += 1) {
        cumulative += visibleCardCount(visibleGroups[groupIndex]);
        if (cumulative >= targetCount) {
          boundaryIndex = groupIndex;
          break;
        }
      }

      var insertionIndex = boundaryIndex + 1;
      if (insertionIndex <= previousInsertionIndex + 1) insertionIndex = previousInsertionIndex + 2;
      insertionIndex = Math.min(insertionIndex, visibleGroups.length);

      if (insertionIndex < visibleGroups.length) {
        visibleGroups[insertionIndex].insertAdjacentElement('beforebegin', promo);
      } else {
        visibleGroups[visibleGroups.length - 1].insertAdjacentElement('afterend', promo);
      }

      previousInsertionIndex = insertionIndex;
      revealJourneyPromo(promo);
    });
  }

  function applyToSection(section) {
    var input = section.querySelector('[data-free-swatches-search-input]');
    if (!input) return;
    if (input.value !== state.query) input.value = state.query;

    var normalizedQuery = normalize(state.query);
    var criteriaActive = Boolean(normalizedQuery || state.productType || state.bestSeller || hasNativeFilterCriteria());
    section.querySelectorAll('[data-cz-extra-gift]').forEach(function (gift) {
      gift.hidden = criteriaActive;
    });
    var emptyCriteriaActive = criteriaActive;
    var matchedCount = 0;

    section.querySelectorAll('[data-free-swatches-group]').forEach(function (group) {
      var groupCount = 0;
      group.querySelectorAll('[data-free-swatches-card]').forEach(function (card) {
        if (criteriaActive) {
          if (!card.hasAttribute('data-search-restore-load-hidden')) {
            card.setAttribute('data-search-restore-load-hidden', card.classList.contains('product-item--hidden') ? 'true' : 'false');
          }
          card.classList.remove('product-item--hidden');
        } else {
          restoreCard(card);
        }
        var typeMatches = cardMatchesProductType(card, state.productType);
        var bestSellerMatches = !state.bestSeller || card.getAttribute('data-best-seller') === 'true';
        var searchMatches = !normalizedQuery || normalize(card.getAttribute('data-search-text')).indexOf(normalizedQuery) !== -1;
        var matches = typeMatches && bestSellerMatches && searchMatches;
        card.hidden = !matches;
        if (matches) {
          groupCount += 1;
          matchedCount += 1;
        }
      });
      group.hidden = groupCount === 0;
    });

    placeJourneyPromos(section, matchedCount, criteriaActive);

    section.querySelectorAll('[data-free-swatches-banner]').forEach(function (banner) {
      banner.hidden = banner.hasAttribute('data-free-swatches-placement-pending');
    });

    bindStoryPromoReveal(section);

    section.querySelectorAll('.load-more-container').forEach(function (button) {
      if (criteriaActive) {
        if (!button.hasAttribute('data-search-previous-display')) {
          button.setAttribute('data-search-previous-display', button.style.display || '');
          button.setAttribute('data-search-previous-hidden', button.hidden ? 'true' : 'false');
        }
        button.hidden = true;
      } else if (button.hasAttribute('data-search-previous-display')) {
        button.style.display = button.getAttribute('data-search-previous-display');
        button.hidden = button.getAttribute('data-search-previous-hidden') === 'true';
        button.removeAttribute('data-search-previous-display');
        button.removeAttribute('data-search-previous-hidden');
      }
    });

    var status = section.querySelector('[data-free-swatches-search-status]');
    if (status) {
      if (normalizedQuery) {
        status.textContent = matchedCount + (matchedCount === 1 ? ' swatch found' : ' swatches found');
      } else {
        status.textContent = '';
      }
    }

    section.querySelectorAll('.free-swatches-search__clear').forEach(function (button) {
      button.hidden = !normalizedQuery;
    });

    var emptyState = section.querySelector('[data-free-swatches-search-empty]');
    if (emptyState) {
      emptyState.hidden = !(emptyCriteriaActive && matchedCount === 0);
      var clear = emptyState.querySelector('[data-free-swatches-search-clear]');
      if (clear && !clear.hasAttribute('data-free-swatches-search-clear-all')) {
        clear.textContent = normalizedQuery ? 'Clear search' : (state.productType ? 'Clear Product Type' : 'Clear Best Sellers');
      }
    }
    var listing = section.querySelector('.filters-adjacent');
    if (listing) listing.hidden = Boolean(emptyCriteriaActive && matchedCount === 0);
  }

  function bindClearButtons(section) {
    section.querySelectorAll('[data-free-swatches-search-clear]').forEach(function (button) {
      if (button.hasAttribute('data-fs-clear-bound')) return;
      button.setAttribute('data-fs-clear-bound', '');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (button.hasAttribute('data-free-swatches-search-clear-all')) {
          state.query = '';
          state.productType = '';
          state.bestSeller = false;
          saveState();

          var url = new URL(window.location.href);
          var nativeCriteriaCleared = false;
          Array.from(url.searchParams.keys()).forEach(function (key) {
            if (key.indexOf('filter.') === 0 || key === 'page') {
              url.searchParams.delete(key);
              nativeCriteriaCleared = true;
            }
          });
          if (nativeCriteriaCleared) {
            window.location.assign(url.toString());
            return;
          }
        } else if (state.query) {
          state.query = '';
        } else {
          state.productType = '';
        }

        var input = section.querySelector('[data-free-swatches-search-input]');
        if (input && !state.query) input.value = '';
        saveState();
        hydrateSection(section);
        if (input) input.focus();
      });
    });
  }

  function bindSearchInput(section) {
    var input = section.querySelector('[data-free-swatches-search-input]');
    if (!input || input.hasAttribute('data-fs-input-bound')) return;
    input.setAttribute('data-fs-input-bound', '');
    input.addEventListener('input', function () {
      state.query = input.value;
      saveState();
      applyToSection(section);
    });
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !input.value) return;
      event.preventDefault();
      event.stopPropagation();
      state.query = '';
      input.value = '';
      saveState();
      applyToSection(section);
      input.focus();
    });
  }

  function hydrateSection(section) {
    ensureEmptyState(section);
    bindSearchInput(section);
    bindClearButtons(section);
    ensureAllPages(section);
    normalizeFilterContent(section);
    syncMaterialAvailability(section);
    syncUnifiedCounts(section);
    renderQuickFilters(section);
    arrangeToolbar(section);
    ensureClientProductTypeFilter(section);
    normalizeFilterContent(section);
    decorateFilterGroups(section);
    renderClientApplied(section);
    renderMobileApplied(section);
    revealAllFilterOptions(section);
    applyToSection(section);
  }

  function hydrateAll() {
    scheduled = false;
    document.querySelectorAll('[data-free-swatches-search]').forEach(function (search) {
      var section = sectionFor(search);
      if (section) hydrateSection(section);
    });
  }

  function scheduleHydrate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(hydrateAll);
  }

  function setProductType(value, section) {
    state.productType = state.productType === value ? '' : value;
    saveState();
    if (section) syncMaterialAvailability(section);
    scheduleHydrate();
  }

  function resetQuickMenuPosition(dropdown) {
    var menu = dropdown && dropdown.querySelector('.free-swatches-quick__menu');
    if (!menu) return;
    menu.style.removeProperty('top');
    menu.style.removeProperty('bottom');
    menu.style.removeProperty('max-height');
  }

  function applyQuickMenuPosition(dropdown) {
    if (!dropdown) return;
    var menu = dropdown.querySelector('.free-swatches-quick__menu');
    var trigger = dropdown.querySelector('[data-fs-quick-trigger]');
    if (!menu || !trigger || window.innerWidth > 767) {
      resetQuickMenuPosition(dropdown);
      return;
    }

    var toolbar = dropdown.closest('.free-swatches-toolbar');
    var anchorRect = toolbar ? toolbar.getBoundingClientRect() : trigger.getBoundingClientRect();
    var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var desiredTop = Math.max(8, Math.round(anchorRect.bottom + 6));
    var available = Math.max(150, Math.round(viewportHeight - desiredTop - 12));

    menu.style.setProperty('top', desiredTop + 'px', 'important');
    menu.style.setProperty('bottom', 'auto', 'important');
    menu.style.setProperty('max-height', Math.min(360, available) + 'px', 'important');

    /* Some theme-preview ancestors create a containing block for fixed children.
       Measure the rendered position and compensate so the menu still sits below
       the visible toolbar instead of drifting into the product grid. */
    var actualTop = Math.round(menu.getBoundingClientRect().top);
    if (Math.abs(actualTop - desiredTop) > 1) {
      menu.style.setProperty('top', (desiredTop + desiredTop - actualTop) + 'px', 'important');
    }
  }

  function positionQuickMenu(dropdown) {
    applyQuickMenuPosition(dropdown);
    window.requestAnimationFrame(function () {
      if (!dropdown || !dropdown.classList.contains('is-open')) return;
      applyQuickMenuPosition(dropdown);
      window.requestAnimationFrame(function () {
        if (dropdown.classList.contains('is-open')) applyQuickMenuPosition(dropdown);
      });
    });
  }

  var quickMenuRepositionFrame = 0;
  function scheduleOpenQuickMenuPosition() {
    if (window.innerWidth > 767 || quickMenuRepositionFrame) return;
    quickMenuRepositionFrame = window.requestAnimationFrame(function () {
      quickMenuRepositionFrame = 0;
      document.querySelectorAll('[data-fs-dropdown].is-open').forEach(function (dropdown) {
        applyQuickMenuPosition(dropdown);
      });
    });
  }

  window.addEventListener('scroll', scheduleOpenQuickMenuPosition, true);
  window.addEventListener('resize', scheduleOpenQuickMenuPosition);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('scroll', scheduleOpenQuickMenuPosition);
    window.visualViewport.addEventListener('resize', scheduleOpenQuickMenuPosition);
  }

  function closeDropdowns(except) {
    document.querySelectorAll('[data-fs-dropdown].is-open').forEach(function (dropdown) {
      if (dropdown === except) return;
      dropdown.classList.remove('is-open');
      resetQuickMenuPosition(dropdown);
      var trigger = dropdown.querySelector('[data-fs-quick-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-free-swatches-search-input]')) return;
    state.query = event.target.value;
    saveState();
    scheduleHydrate();
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('.filters #CollectionFilterForm')) scheduleHydrate();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && event.target.matches('[data-free-swatches-search-input]') && event.target.value) {
      event.preventDefault();
      state.query = '';
      saveState();
      scheduleHydrate();
      event.target.focus();
    } else if (event.key === 'Escape') {
      closeDropdowns();
    }
  });

  document.addEventListener('click', function (event) {
    var bestSellers = event.target.closest('[data-fs-best-sellers]');
    if (bestSellers) {
      event.preventDefault();
      if (!bestSellers.disabled) {
        state.bestSeller = !state.bestSeller;
        saveState();
        scheduleHydrate();
      }
      return;
    }

    var trigger = event.target.closest('[data-fs-quick-trigger]');
    if (trigger) {
      event.preventDefault();
      var dropdown = trigger.closest('[data-fs-dropdown]');
      var opening = !dropdown.classList.contains('is-open');
      closeDropdowns(dropdown);
      dropdown.classList.toggle('is-open', opening);
      trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) positionQuickMenu(dropdown);
      else resetQuickMenuPosition(dropdown);
      return;
    }

    var clearNative = event.target.closest('[data-fs-clear-native-group]');
    if (clearNative) {
      event.preventDefault();
      clearNativeGroup(sectionFor(clearNative), clearNative.getAttribute('data-fs-clear-native-group'));
      closeDropdowns();
      scheduleHydrate();
      return;
    }

    var nativeOption = event.target.closest('[data-fs-native-option]');
    if (nativeOption) {
      event.preventDefault();
      var nativeSection = sectionFor(nativeOption);
      setNativeOption(nativeSection, nativeOption.getAttribute('data-fs-native-group'), nativeOption.getAttribute('data-fs-native-option'));
      closeDropdowns();
      scheduleHydrate();
      return;
    }

    var typeOption = event.target.closest('[data-fs-product-type-option], [data-fs-client-type-option]');
    if (typeOption) {
      event.preventDefault();
      if (typeOption.disabled || typeOption.getAttribute('aria-disabled') === 'true') return;
      setProductType(
        typeOption.getAttribute('data-fs-product-type-option') || typeOption.getAttribute('data-fs-client-type-option'),
        sectionFor(typeOption)
      );
      closeDropdowns();
      return;
    }

    var clearClient = event.target.closest('[data-fs-clear-client]');
    if (clearClient) {
      event.preventDefault();
      if (clearClient.getAttribute('data-fs-clear-client') === 'bestSeller') state.bestSeller = false;
      else state.productType = '';
      saveState();
      closeDropdowns();
      scheduleHydrate();
      return;
    }

    var clearButton = event.target.closest('[data-free-swatches-search-clear]');
    if (clearButton) {
      event.preventDefault();
      if (state.query) state.query = '';
      else if (state.productType) state.productType = '';
      else state.bestSeller = false;
      saveState();
      scheduleHydrate();
      var clearSection = sectionFor(clearButton);
      var input = clearSection && clearSection.querySelector('[data-free-swatches-search-input]');
      if (input) input.focus();
      return;
    }

    if (event.target.closest('.filter-group__clear-link')) {
      state.productType = '';
      state.bestSeller = false;
      saveState();
    }

    if (event.target.closest('[data-toggle-filters]')) {
      window.setTimeout(scheduleHydrate, 0);
    }

    if (!event.target.closest('[data-fs-dropdown]')) closeDropdowns();
  });

  document.addEventListener('shopify:section:load', scheduleHydrate);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.nodeType !== 1 || !mutation.target.matches('.filters-adjacent')) return;
      var section = sectionFor(mutation.target);
      if (section && !mergingSections.has(section)) {
        section.removeAttribute('data-fs-pages-key');
        section.setAttribute('data-fs-pages-state', 'pending');
        section.classList.remove('free-swatches-all-pages-loaded');
      }
    });
    var needsHydrate = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (
          node.matches('[data-free-swatches-card], [data-free-swatches-search], .filter-group, .filters-adjacent, .utility-bar') ||
          node.querySelector('[data-free-swatches-card], [data-free-swatches-search], .filter-group, .filters-adjacent, .utility-bar')
        );
      });
    });
    if (needsHydrate) scheduleHydrate();
  });

  var journeyPromoMedia = window.matchMedia('(max-width: 700px)');

  function init() {
    if (journeyPromoMedia.addEventListener) journeyPromoMedia.addEventListener('change', scheduleHydrate);
    else if (journeyPromoMedia.addListener) journeyPromoMedia.addListener(scheduleHydrate);
    observer.observe(document.body, { childList: true, subtree: true });
    scheduleHydrate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


/* Sub-option icons — 2026-08-08 */
(function () {
  'use strict';

  if (window.__cozyFreeSwatchesSubOptionIconsLoaded) return;
  window.__cozyFreeSwatchesSubOptionIconsLoaded = true;

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function svg(paths, modifier) {
    return '<span class="free-swatches-sub-option-icon' + (modifier ? ' free-swatches-sub-option-icon--' + modifier : '') + '" aria-hidden="true"><svg viewBox="0 0 20 20" role="presentation">' + paths + '</svg></span>';
  }

  var icons = {
    star: '<path d="m10 2.8 2.1 4.3 4.8.7-3.5 3.4.8 4.8-4.2-2.3L5.8 16l.8-4.8-3.5-3.4 4.8-.7z"></path>',
    drapery: '<path d="M3.5 3.5h13v13h-13zM10 3.5v13M6.2 3.5c1.2 3.9 1.2 9.1 0 13M13.8 3.5c-1.2 3.9-1.2 9.1 0 13"></path>',
    sheer: '<path d="M4 3.5h12v13H4zM7 4v12M10 4v12M13 4v12" stroke-dasharray="1.4 2"></path>',
    roman: '<path d="M4 3.5h12v13H4zM4 7h12M4 10.5h12M4 14h12"></path>',
    handwoven: '<path d="M4 3v14M8 3v14M12 3v14M16 3v14M3 5h14M3 10h14M3 15h14"></path>',
    roller: '<path d="M4 5h12v2H4zM5 7v9h10V7M13 3.5h3.5v5"></path><circle cx="16.5" cy="10" r=".8"></circle>',
    linen: '<path d="M4 3v14M8 3v14M12 3v14M16 3v14M3 5h14M3 10h14M3 15h14"></path>',
    cotton: '<path d="M7.2 15.5c-1.8 0-3.2-1.3-3.2-3 0-1.5 1-2.7 2.4-3-.2-.4-.3-.8-.3-1.2 0-1.5 1.2-2.7 2.7-2.7.5 0 1 .1 1.4.4.5-1.2 1.6-2 3-2 1.8 0 3.2 1.4 3.2 3.2 0 .7-.2 1.3-.6 1.8 1 .5 1.7 1.6 1.7 2.8 0 1.8-1.4 3.2-3.2 3.2H7.2zM10 15v2M7 15l-1 2M13 15l1 2"></path>',
    wool: '<path d="M4 12.5c0-4.5 3-7.5 6.5-7.5 3.1 0 5.5 2.2 5.5 5.2 0 2.7-2 4.8-4.6 4.8-2.3 0-4-1.5-4-3.5 0-1.7 1.2-2.9 2.8-2.9 1.3 0 2.3.9 2.3 2.1 0 1-.7 1.7-1.6 1.7"></path>',
    velvet: '<path d="M4 4.5h12v11H4zM7 4.5c.8 3.5.8 7.5 0 11M13 4.5c-.8 3.5-.8 7.5 0 11"></path><path d="M15.5 2.5v2M14.5 3.5h2"></path>',
    blend: '<path d="M3.5 3.5h13v13h-13zM10 3.5v13M4 7h6M4 11h6M4 15h6"></path><path d="M13.5 6.5c1.5 0 2.5 1 2.5 2.3 0 1.4-1.1 2.4-2.5 2.4S11 10.2 11 8.8c0-1.3 1-2.3 2.5-2.3z"></path>',
    bamboo: '<path d="M6 2.8v14.4M14 2.8v14.4M5 6h2M13 9h2M3.5 4.5c2 0 3.2-1 4-2M16.5 6.5c-2 0-3.2-1-4-2"></path>',
    liner: '<path d="M4 4h9v11H4zM7 2.5h9v11"></path>',
    trim: '<path d="M4 3h12v14H4zM7 3v14M13 3v14M7 6h6M7 10h6M7 14h6"></path>',
    leaf: '<path d="M4 15c4-1 7-4 10-10M6 12c-2-2-1-5 2-6M10 9c1-3 4-4 6-3-1 3-3 5-6 5"></path>',
    waves: '<path d="M2.5 6c2.5-2.2 5-2.2 7.5 0s5 2.2 7.5 0M2.5 10c2.5-2.2 5-2.2 7.5 0s5 2.2 7.5 0M2.5 14c2.5-2.2 5-2.2 7.5 0s5 2.2 7.5 0"></path>',
    artisan: '<path d="m10 3 1.4 4.1L15.5 8.5l-4.1 1.4L10 14l-1.4-4.1-4.1-1.4 4.1-1.4zM15.5 13.5l.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6z"></path>',
    solid: '<path d="M4 4h12v12H4zM6.5 13.5l7-7"></path>',
    memory: '<path d="M3 6c3-2 5-2 7 0s4 2 7 0M3 10c3-2 5-2 7 0s4 2 7 0M3 14c3-2 5-2 7 0s4 2 7 0"></path>',
    thermal: '<path d="M7 4a3 3 0 0 1 6 0v7.2a4.5 4.5 0 1 1-6 0zM10 7v6"></path><path d="M15.5 6c1 .8 1.5 2 1.5 3.2M16 13c.7-.6 1-1.2 1.2-2"></path>',
    water: '<path d="M10 2.8c2.7 3.3 5 6 5 8.7a5 5 0 0 1-10 0c0-2.7 2.3-5.4 5-8.7zM7.5 12.2c.3 1.1 1.1 1.8 2.2 2.1"></path>',
    flame: '<path d="M10 2.2c.3 2.2-1 3.6-2.2 4.9-1.3 1.4-2.6 2.9-2.6 5.3a4.8 4.8 0 0 0 9.6 0c0-2.9-1.5-5.3-3.8-7.5.1 2-.6 3.4-1.7 4.6.2-2.8-.5-5.1.7-7.3z"></path><path d="M10 10.2c.3 1.2-.4 1.9-.9 2.5-.4.5-.7 1-.7 1.6a1.6 1.6 0 1 0 3.2 0c0-1.3-.7-2.4-1.6-4.1z"></path>',
    collection: '<path d="M5 3.5h10v10H5zM3 6.5v10h10M7.5 6.5h5M7.5 9h5M7.5 11.5h3"></path>',
    sortup: '<path d="M6 16V4m0 0L3.5 6.5M6 4l2.5 2.5M12 6h5M12 10h4M12 14h3"></path>',
    sortdown: '<path d="M6 4v12m0 0-2.5-2.5M6 16l2.5-2.5M12 6h3M12 10h4M12 14h5"></path>',
    relevant: '<path d="M10 3v14M3 10h14M5 5l10 10M15 5 5 15"></path>',
    priceup: '<path d="M7 15V5m0 0L4.5 7.5M7 5l2.5 2.5M13 4v12M11 6h4M11 10h4M11 14h4"></path>',
    pricedown: '<path d="M7 5v10m0 0-2.5-2.5M7 15l2.5-2.5M13 4v12M11 6h4M11 10h4M11 14h4"></path>',
    calendar: '<path d="M4 5h12v11H4zM7 3v4M13 3v4M4 8h12"></path>'
  };

  var colors = {
    'sheer white': '#f5f3ee', white: '#ffffff', beige: '#cdb894', brown: '#876247',
    yellow: '#d9b650', gray: '#999995', grey: '#999995', black: '#252525',
    pink: '#d8a1aa', purple: '#8d7198', red: '#b45d55', blue: '#6f8fa9', green: '#6f8565'
  };

  function colorDot(label) {
    return '<span class="free-swatches-sub-option-icon free-swatches-sub-option-icon--color" style="--free-swatches-sub-color:' + (colors[normalize(label)] || '#c9c4bb') + '" aria-hidden="true"></span>';
  }

  function iconFor(group, label) {
    var g = normalize(group);
    var l = normalize(label);

    if (g === 'color') return colorDot(label);
    if (g === 'collection') return svg(icons.collection, 'collection');
    if (g === 'best seller' || g === 'best sellers') return svg(icons.star, 'bestseller');

    if (g === 'product type') {
      if (l === 'drapery') return svg(icons.drapery, 'drapery');
      if (l === 'sheer') return svg(icons.sheer, 'sheer');
      if (l === 'roman shade') return svg(icons.roman, 'roman');
      if (l === 'handwoven shade') return svg(icons.handwoven, 'handwoven');
      if (l === 'roller shade') return svg(icons.roller, 'roller');
    }

    if (g === 'fabric' || g === 'material') {
      if (l === 'linen') return svg(icons.linen, 'linen');
      if (l === 'cotton') return svg(icons.cotton, 'cotton');
      if (l === 'wool') return svg(icons.wool, 'wool');
      if (l === 'sheer') return svg(icons.sheer, 'sheer');
      if (l === 'velvet') return svg(icons.velvet, 'velvet');
      if (l === '100 linen cotton') return svg(icons.blend, 'blend');
      if (l === 'woven shade') return svg(icons.handwoven, 'handwoven');
      if (l === 'bamboo shade') return svg(icons.bamboo, 'bamboo');
      if (l === 'roller shade') return svg(icons.roller, 'roller');
      if (l === 'liner') return svg(icons.liner, 'liner');
      if (l === 'border trim') return svg(icons.trim, 'trim');
    }

    if (g === 'light blocking' || g === 'light control') {
      if (l === 'sheer fabric') return svg('<circle cx="10" cy="10" r="3"></circle><path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.7 4.7l1.4 1.4M13.9 13.9l1.4 1.4M15.3 4.7l-1.4 1.4M6.1 13.9l-1.4 1.4"></path>', 'light-sheer');
      if (l === 'light filtering') return svg('<circle cx="10" cy="10" r="6"></circle><path d="M6.5 6.5l7 7M5 9l6 6M9 5l6 6"></path>', 'light-filtering');
      if (l === 'room darkening') return svg('<circle cx="10" cy="10" r="6"></circle><path class="free-swatches-sub-option-icon__fill" d="M10 4a6 6 0 1 0 0 12z"></path>', 'room-darkening');
      if (l === '100 blackout') return svg('<circle class="free-swatches-sub-option-icon__fill" cx="10" cy="10" r="6"></circle>', 'blackout');
    }

    if (g === 'texture') {
      if (l === 'solid and natural') return svg(icons.solid, 'solid');
      if (l === 'botanical weave') return svg(icons.leaf, 'botanical');
      if (l === 'textured weave') return svg(icons.waves, 'textured');
      if (l === 'artisan collection') return svg(icons.artisan, 'artisan');
      if (l === 'classic checks and stripes') return svg(icons.handwoven, 'checks');
    }

    if (g === 'function') {
      if (l === 'memory shaped') return svg(icons.memory, 'memory');
      if (l === 'self lined liner free') return svg(icons.liner, 'self-lined');
      if (l === 'thermal noise') return svg(icons.thermal, 'thermal');
      if (l === 'water resistant') return svg(icons.water, 'water');
      if (l === 'flame retardant') return svg(icons.flame, 'flame');
    }

    if (g === 'sort by') {
      if (l === 'featured' || l === 'best selling') return svg(icons.star, 'featured');
      if (l === 'most relevant') return svg(icons.relevant, 'relevant');
      if (l.indexOf('alphabetically a z') === 0 || l.indexOf('price low') === 0) return svg(l.indexOf('price') === 0 ? icons.priceup : icons.sortup, 'ascending');
      if (l.indexOf('alphabetically z a') === 0 || l.indexOf('price high') === 0) return svg(l.indexOf('price') === 0 ? icons.pricedown : icons.sortdown, 'descending');
      if (l.indexOf('date ') === 0) return svg(icons.calendar, 'date');
    }

    return svg(icons.collection, 'generic');
  }

  function cleanText(node) {
    if (!node) return '';
    var copy = node.cloneNode(true);
    copy.querySelectorAll('svg, .free-swatches-sub-option-icon, .free-swatches-color-dot, .free-swatches-control-icon').forEach(function (icon) { icon.remove(); });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function decorateSidebar(root) {
    root.querySelectorAll('.filters #CollectionFilterForm .filter-group:not(.filter-group--applied)').forEach(function (group) {
      var heading = group.querySelector('.filter-group__heading__text');
      var groupLabel = cleanText(heading);
      if (!groupLabel) return;
      group.querySelectorAll('.filter-group__item').forEach(function (item) {
        var text = item.querySelector('.filter-group__item__text');
        if (!text || text.querySelector('.free-swatches-sub-option-icon')) return;
        var label = cleanText(text);
        if (!label) return;
        text.insertAdjacentHTML('afterbegin', iconFor(groupLabel, label));
      });
    });
  }

  function decorateQuick(root) {
    root.querySelectorAll('[data-fs-native-group] .free-swatches-quick__option-label').forEach(function (labelNode) {
      if (labelNode.querySelector('.free-swatches-sub-option-icon, .free-swatches-color-dot')) return;
      var button = labelNode.closest('[data-fs-native-group]');
      var group = button && button.getAttribute('data-fs-native-group');
      var label = cleanText(labelNode);
      if (normalize(group) === 'color') return;
      labelNode.insertAdjacentHTML('afterbegin', iconFor(group, label));
    });

    root.querySelectorAll('[data-fs-product-type-option] .free-swatches-quick__option-label').forEach(function (labelNode) {
      var old = labelNode.querySelector('.free-swatches-control-icon');
      if (old) old.remove();
      if (labelNode.querySelector('.free-swatches-sub-option-icon')) return;
      labelNode.insertAdjacentHTML('afterbegin', iconFor('Product Type', cleanText(labelNode)));
    });
  }

  function decorate(root) {
    decorateSidebar(root || document);
    decorateQuick(root || document);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      decorate(document);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) schedule();
  });

  function init() {
    decorate(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


/* Native option parity + live sticky offset — 2026-08-08 */
(function () {
  'use strict';

  if (window.__cozyFreeSwatchesParityStickyV2) return;
  window.__cozyFreeSwatchesParityStickyV2 = true;

  var scheduled = false;

  function normalizeNativeRows(root) {
    (root || document).querySelectorAll(
      '.filters #CollectionFilterForm label.filter-group__item'
    ).forEach(function (item) {
      var input = item.querySelector(':scope > .filter-group__checkbox');
      var text = item.querySelector(':scope > .filter-group__item__text');
      if (!input || !text) return;

      item.classList.add('free-swatches-native-option');
      item.querySelectorAll(':scope > .free-swatches-native-option__box').forEach(function (box) {
        box.remove();
      });
    });
  }

  function syncStickyOffsets() {
    var root = document.documentElement;
    var toolbar = document.querySelector('.utility-bar.free-swatches-toolbar');
    if (!toolbar) return;

    var headerBottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group.section-header, .section-header').forEach(function (header) {
      var rect = header.getBoundingClientRect();
      var style = window.getComputedStyle(header);
      if (rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden') {
        headerBottom = Math.max(headerBottom, rect.bottom);
      }
    });

    if (headerBottom <= 0) {
      headerBottom = parseFloat(window.getComputedStyle(root).getPropertyValue('--theme-sticky-header-height')) || 0;
    }

    root.style.setProperty('--free-swatches-toolbar-top', Math.max(0, Math.ceil(headerBottom)) + 'px');
    root.style.setProperty('--free-swatches-toolbar-height', Math.ceil(toolbar.getBoundingClientRect().height) + 'px');
  }

  function run() {
    scheduled = false;
    normalizeNativeRows(document);
    if (document.querySelector('.utility-bar.free-swatches-toolbar')) {
      document.body.classList.add('free-swatches-filter-search-page');
    }
    syncStickyOffsets();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) schedule();
  });

  function init() {
    run();
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
/* End native option parity + live sticky offset */


/* Page scope for sticky ownership — 2026-08-08 */
(function () {
  'use strict';
  function markPage() {
    if (document.querySelector('.utility-bar.free-swatches-toolbar')) {
      document.body.classList.add('free-swatches-filter-search-page');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markPage, { once: true });
  else markPage();
})();
/* End page scope for sticky ownership */


/* Compact expandable mobile search — preserve query, restore toolbar after results update. */
(function () {
  'use strict';

  if (window.__cozyFreeSwatchesMobileSearchV1) return;
  window.__cozyFreeSwatchesMobileSearchV1 = true;

  function setOpen(search, open, focusInput) {
    if (!search) return;
    var input = search.querySelector('[data-free-swatches-search-input]');
    var toggle = search.querySelector('[data-fs-mobile-search-toggle]');
    var isMobile = window.innerWidth <= 767;
    var nextOpen = Boolean(isMobile && open);

    search.classList.toggle('is-mobile-open', nextOpen);
    if (toggle) {
      toggle.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', nextOpen ? 'Search swatches' : 'Open swatch search');
    }

    if (input) {
      if (isMobile) input.tabIndex = nextOpen ? 0 : -1;
      else input.removeAttribute('tabindex');
      if (nextOpen && focusInput) {
        window.requestAnimationFrame(function () {
          input.focus();
        });
      }
    }
  }

  function bind(search) {
    if (!search || search.hasAttribute('data-fs-mobile-search-bound')) return;
    var input = search.querySelector('[data-free-swatches-search-input]');
    var toggle = search.querySelector('[data-fs-mobile-search-toggle]');
    var close = search.querySelector('[data-fs-mobile-search-close]');
    if (!input || !toggle || !close) return;

    var positionAnchor = null;

    function capturePosition() {
      if (window.innerWidth > 767) {
        positionAnchor = null;
        return;
      }

      var rect = search.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
        positionAnchor = null;
        return;
      }

      positionAnchor = {
        top: rect.top,
        expiresAt: Date.now() + 700
      };
    }

    function restorePosition() {
      if (!positionAnchor || window.innerWidth > 767 || Date.now() > positionAnchor.expiresAt) {
        positionAnchor = null;
        return;
      }

      var delta = search.getBoundingClientRect().top - positionAnchor.top;
      if (Math.abs(delta) > 0.5) window.scrollBy(0, delta);
    }

    function settlePosition() {
      restorePosition();
      window.requestAnimationFrame(function () {
        restorePosition();
        window.requestAnimationFrame(restorePosition);
      });
      window.setTimeout(restorePosition, 120);
    }

    search.setAttribute('data-fs-mobile-search-bound', '');

    toggle.addEventListener('click', function (event) {
      if (window.innerWidth > 767) {
        input.focus();
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      setOpen(search, true, true);
    });

    close.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (input.value) {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      setOpen(search, false, false);
      toggle.focus();
    });

    input.addEventListener('beforeinput', capturePosition);

    input.addEventListener('input', function () {
      var hasQuery = Boolean(input.value.trim());
      search.classList.toggle('has-mobile-query', hasQuery);
      if (window.innerWidth <= 767) {
        setOpen(search, hasQuery, false);
        if (!hasQuery && document.activeElement === input) toggle.focus();
      }
      window.queueMicrotask(settlePosition);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && input.value.trim()) {
        input.blur();
        return;
      }
      if (event.key !== 'Escape') return;
      window.setTimeout(function () {
        if (!input.value) {
          setOpen(search, false, false);
          toggle.focus();
        }
      }, 0);
    });

    /* Keep a saved or restored query visible until the customer clears it. */
    var hasRestoredQuery = Boolean(input.value.trim());
    search.classList.toggle('has-mobile-query', hasRestoredQuery);
    setOpen(search, hasRestoredQuery, false);
  }

  function bindAll(root) {
    (root || document).querySelectorAll('[data-free-swatches-search]').forEach(bind);
  }

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) {
      bindAll(document);
    }
  });

  function init() {
    bindAll(document);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-free-swatches-search]').forEach(function (search) {
        var input = search.querySelector('[data-free-swatches-search-input]');
        setOpen(search, Boolean(input && input.value.trim()), false);
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
/* End compact expandable mobile search */

/* Mobile filter drawer: keep the tapped option stationary while filters re-render — 2026-08-17 */
(function () {
  'use strict';

  var anchor = null;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function optionFor(target) {
    return target && target.closest(
      '.filters #CollectionFilterForm label.filter-group__item, ' +
      '.filters #CollectionFilterForm [data-fs-client-type-option], ' +
      '.filters #CollectionFilterForm [data-fs-best-sellers]'
    );
  }

  function scrollContainerFor(option) {
    var node = option;
    var filters = option && option.closest('.filters');
    while (node && filters && filters.contains(node)) {
      var style = window.getComputedStyle(node);
      if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
      node = node.parentElement;
    }
    return filters;
  }

  function optionKey(option) {
    var input = option.querySelector('input');
    if (input) return 'input:' + (input.name || '') + ':' + (input.value || '');

    var clientValue = option.getAttribute('data-fs-client-type-option');
    if (clientValue) return 'client:' + clientValue;
    if (option.hasAttribute('data-fs-best-sellers')) return 'client:best-sellers';

    return 'text:' + option.textContent.replace(/\s+/g, ' ').trim();
  }

  function findOption(key) {
    var options = document.querySelectorAll(
      '.filters #CollectionFilterForm label.filter-group__item, ' +
      '.filters #CollectionFilterForm [data-fs-client-type-option], ' +
      '.filters #CollectionFilterForm [data-fs-best-sellers]'
    );
    for (var i = 0; i < options.length; i += 1) {
      if (optionKey(options[i]) === key) return options[i];
    }
    return null;
  }

  function capture(target) {
    if (!isMobile()) {
      anchor = null;
      return;
    }
    var option = optionFor(target);
    if (!option) {
      anchor = null;
      return;
    }
    var scroller = scrollContainerFor(option);
    if (!scroller) return;

    anchor = {
      key: optionKey(option),
      viewportTop: option.getBoundingClientRect().top,
      expiresAt: Date.now() + 1400
    };
  }

  function restore() {
    if (!anchor || Date.now() > anchor.expiresAt || !isMobile()) {
      anchor = null;
      return;
    }

    var option = findOption(anchor.key);
    if (!option) return;
    var scroller = scrollContainerFor(option);
    if (!scroller) return;

    var delta = option.getBoundingClientRect().top - anchor.viewportTop;
    if (Math.abs(delta) > 0.5) scroller.scrollTop += delta;
  }

  document.addEventListener('pointerdown', function (event) {
    capture(event.target);
  }, true);

  document.addEventListener('change', function (event) {
    if (!optionFor(event.target)) return;
    window.queueMicrotask(restore);
  }, true);

  var observer = new MutationObserver(function () {
    if (anchor) restore();
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
